import { render, staticRenderFns } from "./QuiltyResourceFilePane.vue?vue&type=template&id=72a520f6&"
import script from "./QuiltyResourceFilePane.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceFilePane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports